import React, { useEffect, useState } from 'react';
import { Nav, Row, Col } from 'react-bootstrap';
import '../settingscommon.scss';
import '../User/user.scss';
import '../EmailProvider/emailprovider.scss';
import { Link, withRouter } from 'react-router-dom';
import Gmail from '../../../assets/images/Gmail.svg';
import Smtp from '../../../assets/images/Smtp.svg';
import { useMutation } from '@apollo/client';
import { SEND_CONSENT_CODE } from '../../../gql/gmail/mutation';
// import { Spinner } from 'react-bootstrap';
import { GMAIL_REDIRECT_URL, OAUTH_CLIENT_ID } from '../../../configUrl';
import RightArrow from '../../../assets/images/right-arrow.svg';
// import Loader from '../../loader/Loader';

import Loaders from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

function EmailProvider({ location, history }) {

    const [googleCode, setGoogleCode] = useState('')

    const userInfo = JSON.parse(localStorage.getItem('user'))

    const [sendCode, {loading}] = useMutation(SEND_CONSENT_CODE, {
        onCompleted(data){
            if(data?.createGmailAuth?.email){
                history.push('/settings/email-provider/google-email')
            }
        },
        refetchQueries: [
            'Me'
        ]
    })

    useEffect(() => {
        if (location.search) {
            const authorizeCode = location.search.split("=")[1].split("&")[0]
            setGoogleCode(authorizeCode)
            if(authorizeCode){
                sendCode({
                    variables: {
                        authorizeCodeInput: {
                            authorizeCode: authorizeCode
                        } 
                    }
                })
            }
            let user = {
                ...userInfo,
                gmailActive: true
            }
            localStorage.setItem('user', JSON.stringify(user))
        }
        // eslint-disable-next-line
    }, [location])

    if(loading){
        return <div className="spinner" >
        <Loaders
            type="ThreeDots"
            color="#192f60"
            height={70}
            width={70}
            timeout={3000}
        />
    </div>
    }

    if(googleCode){
        return <div className="spinner" >
        <Loaders
            type="ThreeDots"
            color="#192f60"
            height={70}
            width={70}
            timeout={3000}
        />
    </div>
    }


    return <div>
        <h1 className='page-title'>Settings</h1>
        <Nav
            className='setting-menu'
        >
            <Nav.Item>
                <Link to="/settings/user" className='nav-link'>User</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/email-provider" className='nav-link active'>Email Provider</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/text-provider" className='nav-link'>SMS Provider</Link>
            </Nav.Item>
            <Nav.Item>
                <Link to="/settings/email-signature" className='nav-link'>Email Signature</Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Link to="/settings/billing" className='nav-link'>Billing</Link>
            </Nav.Item> */}
        </Nav>
        <div className='profile-sec'>
            <p>Email provider that will be use to send emails.</p>
            <h4>Simply connect your email provider to get started</h4>
            <Row className='email-blocks-row'>
                <Col sm={4}>
                    {/* <a href={`https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${OAUTH_CLIENT_ID}&redirect_uri=${GMAIL_REDIRECT_URL}&response_type=code&scope=email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fgmail.modify&access_type=offline&prompt=consent&flowName=GeneralOAuthFlow`} > */}
                    <a href={`https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${OAUTH_CLIENT_ID}&redirect_uri=${GMAIL_REDIRECT_URL}&response_type=code&scope=email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fgmail.modify%20https%3A%2F%2Fmail.google.com%2F&access_type=offline&prompt=consent&flowName=GeneralOAuthFlow`} >
                        <div className='email-provider-div'>
                            <div className='icon-div'>
                                <img src={Gmail} alt="icon" />
                            </div>
                            <div className='right-content'>
                                <div className='text'>
                                    <span>GOOGLE</span>
                                    <p>Gmail/G-Suite</p>
                                </div>
                                <img src={RightArrow} alt="arrow" />
                            </div>
                        </div>
                    </a>
                </Col>
                
                <Col sm={4}>
                    <Link to="/settings/email-provider/smtp">
                        <div className='email-provider-div'>
                            <div className='icon-div'>
                                <img src={Smtp} alt="icon" />
                            </div>
                            <div className='right-content'>
                                <div className='text'>
                                    <p>SMTP</p>
                                </div>
                                <img src={RightArrow} alt="arrow" />
                            </div>
                        </div>
                    </Link>
                </Col>
            </Row>
        </div>
    </div>;
}

export default withRouter(EmailProvider);
